import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="control-group">
  <label class="control-label" for="flair_url">{{i18n
      "groups.flair_url"
    }}</label>

  <div class="radios">
    <label class="radio-label" for="avatar-flair-icon">
      <RadioButton
        @name="avatar-flair-icon"
        @id="avatar-flair-icon"
        @value="icon"
        @selection={{this.model.flair_type}}
      />
      {{i18n "groups.flair_type.icon"}}
    </label>

    <label class="radio-label" for="avatar-flair-image">
      <RadioButton
        @name="avatar-flair-image"
        @id="avatar-flair-image"
        @value="image"
        @selection={{this.model.flair_type}}
      />
      {{i18n "groups.flair_type.image"}}
    </label>
  </div>

  {{#if this.flairPreviewIcon}}
    <IconPicker
      @name="icon"
      @value={{this.model.flair_icon}}
      @options={{hash maximum=1}}
      @onChange={{fn (mut this.model.flair_icon)}}
    />
  {{else if this.flairPreviewImage}}
    <UppyImageUploader
      @imageUrl={{this.flairImageUrl}}
      @onUploadDone={{action "setFlairImage"}}
      @onUploadDeleted={{action "removeFlairImage"}}
      @type="group_flair"
      @id="group-flair-uploader"
      class="no-repeat contain-image"
    />
    <div class="control-instructions">
      {{i18n "groups.flair_upload_description"}}
    </div>
  {{/if}}
</div>

<div class="control-group">
  <label class="control-label" for="flair_bg_color">{{i18n
      "groups.flair_bg_color"
    }}</label>

  <TextField
    @name="flair_bg_color"
    @value={{this.model.flair_bg_color}}
    @placeholderKey="groups.flair_bg_color_placeholder"
    class="group-flair-bg-color input-xxlarge"
  />
</div>

{{#if this.flairPreviewIcon}}
  <div class="control-group">
    <label class="control-label" for="flair_color">{{i18n
        "groups.flair_color"
      }}</label>

    <TextField
      @name="flair_color"
      @value={{this.model.flair_color}}
      @placeholderKey="groups.flair_color_placeholder"
      class="group-flair-color input-xxlarge"
    />
  </div>
{{/if}}

<div class="control-group">
  <label class="control-label">{{this.flairPreviewLabel}}</label>

  <div class="avatar-flair-preview">
    <div class="avatar-wrapper">
      <img
        width="45"
        height="45"
        src={{this.demoAvatarUrl}}
        class="avatar actor"
        alt=""
      />
    </div>

    {{#if
      (or
        this.model.flair_icon
        this.flairImageUrl
        this.model.flairBackgroundHexColor
      )
    }}
      <AvatarFlair
        @flairName={{this.model.name}}
        @flairUrl={{if
          this.flairPreviewIcon
          this.model.flair_icon
          (if this.flairPreviewImage this.flairImageUrl "")
        }}
        @flairBgColor={{this.model.flairBackgroundHexColor}}
        @flairColor={{this.model.flairHexColor}}
      />
    {{/if}}
  </div>
</div>
*/
{
  "id": "Yt2i5Wrp",
  "block": "[[[10,0],[14,0,\"control-group\"],[12],[1,\"\\n  \"],[10,\"label\"],[14,0,\"control-label\"],[14,\"for\",\"flair_url\"],[12],[1,[28,[35,0],[\"groups.flair_url\"],null]],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"radios\"],[12],[1,\"\\n    \"],[10,\"label\"],[14,0,\"radio-label\"],[14,\"for\",\"avatar-flair-icon\"],[12],[1,\"\\n      \"],[8,[39,1],null,[[\"@name\",\"@id\",\"@value\",\"@selection\"],[\"avatar-flair-icon\",\"avatar-flair-icon\",\"icon\",[30,0,[\"model\",\"flair_type\"]]]],null],[1,\"\\n      \"],[1,[28,[35,0],[\"groups.flair_type.icon\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,\"label\"],[14,0,\"radio-label\"],[14,\"for\",\"avatar-flair-image\"],[12],[1,\"\\n      \"],[8,[39,1],null,[[\"@name\",\"@id\",\"@value\",\"@selection\"],[\"avatar-flair-image\",\"avatar-flair-image\",\"image\",[30,0,[\"model\",\"flair_type\"]]]],null],[1,\"\\n      \"],[1,[28,[35,0],[\"groups.flair_type.image\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"flairPreviewIcon\"]],[[[1,\"    \"],[8,[39,3],null,[[\"@name\",\"@value\",\"@options\",\"@onChange\"],[\"icon\",[30,0,[\"model\",\"flair_icon\"]],[28,[37,4],null,[[\"maximum\"],[1]]],[28,[37,5],[[28,[37,6],[[30,0,[\"model\",\"flair_icon\"]]],null]],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"flairPreviewImage\"]],[[[1,\"    \"],[8,[39,7],[[24,0,\"no-repeat contain-image\"]],[[\"@imageUrl\",\"@onUploadDone\",\"@onUploadDeleted\",\"@type\",\"@id\"],[[30,0,[\"flairImageUrl\"]],[28,[37,8],[[30,0],\"setFlairImage\"],null],[28,[37,8],[[30,0],\"removeFlairImage\"],null],\"group_flair\",\"group-flair-uploader\"]],null],[1,\"\\n    \"],[10,0],[14,0,\"control-instructions\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"groups.flair_upload_description\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],null]],[]]],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n  \"],[10,\"label\"],[14,0,\"control-label\"],[14,\"for\",\"flair_bg_color\"],[12],[1,[28,[35,0],[\"groups.flair_bg_color\"],null]],[13],[1,\"\\n\\n  \"],[8,[39,9],[[24,0,\"group-flair-bg-color input-xxlarge\"]],[[\"@name\",\"@value\",\"@placeholderKey\"],[\"flair_bg_color\",[30,0,[\"model\",\"flair_bg_color\"]],\"groups.flair_bg_color_placeholder\"]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"flairPreviewIcon\"]],[[[1,\"  \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n    \"],[10,\"label\"],[14,0,\"control-label\"],[14,\"for\",\"flair_color\"],[12],[1,[28,[35,0],[\"groups.flair_color\"],null]],[13],[1,\"\\n\\n    \"],[8,[39,9],[[24,0,\"group-flair-color input-xxlarge\"]],[[\"@name\",\"@value\",\"@placeholderKey\"],[\"flair_color\",[30,0,[\"model\",\"flair_color\"]],\"groups.flair_color_placeholder\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n  \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,[30,0,[\"flairPreviewLabel\"]]],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"avatar-flair-preview\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"avatar-wrapper\"],[12],[1,\"\\n      \"],[10,\"img\"],[14,\"width\",\"45\"],[14,\"height\",\"45\"],[15,\"src\",[30,0,[\"demoAvatarUrl\"]]],[14,0,\"avatar actor\"],[14,\"alt\",\"\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[28,[37,10],[[30,0,[\"model\",\"flair_icon\"]],[30,0,[\"flairImageUrl\"]],[30,0,[\"model\",\"flairBackgroundHexColor\"]]],null],[[[1,\"      \"],[8,[39,11],null,[[\"@flairName\",\"@flairUrl\",\"@flairBgColor\",\"@flairColor\"],[[30,0,[\"model\",\"name\"]],[52,[30,0,[\"flairPreviewIcon\"]],[30,0,[\"model\",\"flair_icon\"]],[52,[30,0,[\"flairPreviewImage\"]],[30,0,[\"flairImageUrl\"]],\"\"]],[30,0,[\"model\",\"flairBackgroundHexColor\"]],[30,0,[\"model\",\"flairHexColor\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[],false,[\"i18n\",\"radio-button\",\"if\",\"icon-picker\",\"hash\",\"fn\",\"mut\",\"uppy-image-uploader\",\"action\",\"text-field\",\"or\",\"avatar-flair\"]]",
  "moduleName": "discourse/components/group-flair-inputs.hbs",
  "isStrictMode": false
});